export default {
  FE_BACK_LINK: 'feBackLink',
}
